import { render } from "./TopToolComp.vue?vue&type=template&id=cfc834d0&scoped=true"
import script from "./TopToolComp.vue?vue&type=script&lang=js"
export * from "./TopToolComp.vue?vue&type=script&lang=js"

import "./TopToolComp.vue?vue&type=style&index=0&id=cfc834d0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc834d0"]])

export default __exports__